import { vTooltip } from 'floating-vue'
import type { DirectiveBinding } from 'vue'

function withTheme(binding: DirectiveBinding) {
  return {
    ...binding,
    value: binding.value
      ? { content: binding.value, theme: 'prime-tooltip' }
      : null
  }
}

export const vPrimeTooltip = {
  beforeMount: (el: HTMLElement, binding: DirectiveBinding, vnode: any, prevVnode: any) =>
    vTooltip.beforeMount(el, withTheme(binding), vnode, prevVnode),

  updated: (el: HTMLElement, binding: DirectiveBinding, vnode: any, prevVnode: any) =>
    vTooltip.updated(el, withTheme(binding), vnode, prevVnode),

  beforeUnmount: vTooltip.beforeUnmount
}
